import React from "react";
import { Link } from "react-router-dom";

const GalleryCard = ({ source, description, label, linkTo }) => {
  return (
    <Link to={linkTo} className='galleryCard' aria-label={description}>
      <div className='galleryCardImageWrap'>
        <img
          src={source}
          alt={description}
          className='galleryCardImage'
          loading='lazy'
        />
        <div className='galleryCardScrim' />
        <div className='galleryCardOverlay'>
          <h2 className='galleryCardTitle'>{label}</h2>
          <div className='galleryCardUnderline' />
        </div>
      </div>
    </Link>
  );
};

export default GalleryCard;
